export default __webpack_public_path__ + "static/media/photo--lg--wheel-9.ebac635e.jpg";